import { GetterTree } from 'vuex';

// Shared types
import { Product, AdditionalProduct, ServiceProduct } from '@coldtec/cos-types';

// Store and store types
import Store from '@/store';
import { RootState, ProductsGetter, ToolProduct, ToolProducts } from '@/store/store.types';

/**
 *
 *  Used to sort the provided products on index.
 *
 *  @param products The original products Array
 *
 *  @returns The sorted products Array
 *
 */
function sortProducts<P extends Product>(products: ToolProducts<P>): ToolProducts<P> {

    return products.sort((a: ToolProduct<P>, b: ToolProduct<P>) => a.data.index - b.data.index);

}

/**
 *  Holding every getter of the products.
 */
export const Getters: GetterTree<RootState, RootState> = {

    /**
     *  Used to get all the additional products, sorted on index.
     */
    [ProductsGetter.ADDITIONAL](state: RootState): ToolProducts<AdditionalProduct> {

        return sortProducts<AdditionalProduct>(state.products.additional);

    },

    /**
     *  Used to get all the service products, sorted on index.
     */
    [ProductsGetter.SERVICE](state: RootState): ToolProducts<ServiceProduct> {

        return sortProducts<ServiceProduct>(state.products.service);

    },

    /**
     *  Used to get all the products, unsorted.
     */
    [ProductsGetter.ALL](state: RootState): ToolProducts {

        return [
            ...state.products.additional,
            ...state.products.service,
        ];

    },

    /**
     *  Used to get the amount of selected products.
     */
    [ProductsGetter.SELECTED_COUNT](): number {

        let count = 0;

        for (const product of Store.getters[ProductsGetter.ALL] as ToolProducts) {

            if (!product.selected) {

                continue;

            }

            count++;

        }

        return count;

    },

};
